module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf.3fb1e4ae.svg";